/* globals txt */

const objectPathToKey = require('./objectPathToKey');
const FormBuilder     = require('./form-builder');
const irmFunctions    = require('../../../src/inlinerecordmanagement/js/irm-shared-functions');

module.exports = function ContentManagementDisplayForm (cmtTargetElementId, options) {
  var cmt = this;

  cmt.options               = options;
  cmt.targetElement         = document.getElementById(cmtTargetElementId);
  cmt.eventListeners        = [];
  cmt.displayRows           = [];
  cmt.currentRecordIndex    = 0;
  cmt.saveHookCallBack      = null;

  cmt.defaults = {
    data    : {},
    columns : {
      drug : {
        display    : 'text',
        columnName : 'Drug'
      }
    },
    tableAttributes : [],
    uid             : 'cmt'
  };

  cmt.settings = $.extend( {}, cmt.defaults, cmt.options );

  cmt.buildDataDisplay = function () {

    var  newRecordButtonTopId = 'new-' + cmt.settings.formType + '-button-top';

    cmt.dataContainer = document.createElement('ul');

    cmt.settings.contentDisplaySettings.callableFunctions.deleteButtonAction = cmt.settings.contentDisplaySettings.callableFunctions.deleteButtonAction.bind(cmt) || cmt.deleteRecord;

    cmt.settings.contentClass.options.callableFunctions.cancelButtonAction = cmt.settings.contentClass.options.callableFunctions.cancelButtonAction;

    cmt.addAttributes(cmt.dataContainer, cmt.settings.tableAttributes);
    cmt.dataContainer.setAttribute('id', cmt.settings.uid);
    cmt.dataContainer.classList.add('cmt__data-display');
    cmt.targetElement.appendChild(cmt.dataContainer);
    cmt.dataContainer.appendChild(cmt.createNewRecordButton(newRecordButtonTopId));

    if (typeof cmt.settings.data !== 'undefined' && cmt.settings.data.length > 0) {
      cmt.buildListing(cmt.dataContainer);
      cmt.createNewRecordButtonAtBottom();
    }
  };

  cmt.createNewRecordButton = function (buttonId) {
    var buttonRow = document.createElement('li'),
        button = document.createElement('button');

    [cmt.settings.uid + '__add-button', 'dtx-button', 'button-secondary', 'cmt__button--new-form', 'form__button--no-side-margin'].forEach(function (className) {
      button.classList.add(className);
    });
    var newRecordTextKey = 'new_' + cmt.settings.formTypeTextKey;
    button.textContent = txt[newRecordTextKey];

    if (typeof options.isEditable === 'undefined' || typeof options.isEditable === 'function' && options.isEditable()) {
      button.addEventListener('click',  function (event) {
        event.stopPropagation();
        event.preventDefault();
        cmt.createNewForm();
      });
    } else {
      button.setAttribute('disabled', 'disabled');
    }
    button.setAttribute('data-data-view-row-index',cmt.currentRecordIndex);
    button.setAttribute('type','button');
    buttonRow.classList.add('cmt__button-row');
    buttonRow.classList.add('grid-row');
    buttonRow.appendChild(button);
    buttonRow.id=buttonId;
    return buttonRow;
  };

  cmt.createNewRecordButtonAtBottom = function () {
    const newRecordButtonBottomId = 'new-' + cmt.settings.formType + '-button-bottom';

    const currentBtn = cmt.targetElement.querySelector(`#${newRecordButtonBottomId}`);
    if(!currentBtn) {
      cmt.dataContainer.appendChild(cmt.createNewRecordButton(newRecordButtonBottomId));
    } else {
      cmt.dataContainer.removeChild(currentBtn);
      cmt.dataContainer.appendChild(currentBtn);
    }
  }

  cmt.addAttributes = function (element, attributesObject) {

    Object.keys(attributesObject).map(function (key) {
      var value = attributesObject[key];

      if (key === 'html') {
        element.innerHTML = value;
        return false;
      }

      element.setAttribute(key, value);
    });
  };

  cmt.buildListing = function () {
    var i,
        data = cmt.settings.data;

    for (i = 0; i < data.length; i++) {
      cmt.displayCreatedRecord(data[i]);
    }
  };

  cmt.displayCreatedRecord = function (data) {
    const recordContainer = document.createElement('li');
    const displaySettings = cmt.settings.contentDisplaySettings;
    const recordIndex     = cmt.currentRecordIndex;
    const recordId        = cmt.settings.uid + '-row_' + recordIndex;

    recordContainer.recordId = recordIndex;
    recordContainer.classList.add(cmt.settings.uid + '__row');
    recordContainer.classList.add(recordId);
    recordContainer.setAttribute('id', recordId);
    cmt.dataContainer.appendChild(recordContainer);

    displaySettings.uid = recordId;

    displaySettings.callableFunctions.createNewEditForm = function (event) {
      if (typeof options.isEditable === 'undefined' || typeof options.isEditable === 'function' && options.isEditable()) {
        cmt.createNewEditForm(event);
      }
    }.bind(cmt);

    displaySettings.inputNameSuffix = recordId;

    ['deleteRowBottom', 'editRowBottom'].forEach(function(key) {
      var objectPath = objectPathToKey(displaySettings.structure, key);
      // Null check in case spscFieldset global is set (IQ-8793)
      if(objectPath) {
        objectPath.object.attributes['data-record-id'] = recordIndex; // TODO delete this?
        objectPath.object.attributes['data-answers-id'] = data.answersId;
      }
    });

    cmt.displayRows[recordIndex] = new FormBuilder(recordContainer, displaySettings, data);

    if (typeof options.isEditable === 'function' && !options.isEditable()) {
      $(displaySettings.structure.editBottomRow.domWrapper)
        .find('button')
        .attr('disabled', 'disabled');
    }

    cmt.currentRecordIndex++;

    // This ensures that the data stripes don't get assigned to hidden rows - not currently possible with pure css
    const $visibleEvenRows = $(recordContainer).find('.foBu__content > div').filter(`:not(:hidden):${cmt.settings.displayStriping}`);
    $visibleEvenRows.addClass('data-stripes');

    return recordContainer;
  };

  cmt.enableEditButton = function(isEnabled) {
    const parentId = cmt.settings.uid;
    const messageDisplayValue = isEnabled ? 'none' : 'inline';

    // make sure we don't enable it if it's not editable. This shouldn't happen as read only forms don't have a new
    // meds / equip button
    if(isEnabled) {
      if(typeof options.isEditable === 'function' && !options.isEditable()) {
        return;
      }
    }

    // disable / enable the edit button
    $(`#${cmtTargetElementId} #${parentId} .cmt__button--edit-form`).prop('disabled', !isEnabled);
    // show / hide the related message
    $(`#${cmtTargetElementId} #${parentId} div.edit-row-bottom-message > span`).css('display', messageDisplayValue);
  }

  cmt.createNewForm = function (event) {
    if(cmt.currentForm) {
      return;
    }

    cmt.toggleNewFormButtons(false);
    cmt.enableEditButton(false);

    const existingData = { 'dataViewRecordIndex': cmt.currentRecordIndex };
    const formWrapper = cmt.createNewFormWrapper();

    cmt.currentForm = new FormBuilder(formWrapper, cmt.settings.contentClass.options, existingData);
  };

  cmt.createNewFormWrapper = function () {
    const wrapper = document.createElement('div');
    cmt.newFormWrapper = wrapper;
    wrapper.classList.add('cmt-inline__content');

    cmt.targetElement.appendChild(wrapper);
    return wrapper;
  };

  cmt.createNewEditForm = function (event) {
    event.stopPropagation();
    event.preventDefault();

    cmt.toggleNewFormButtons(false);
    cmt.enableEditButton(false);
    // Disable the edit button
    const parentId = cmt.settings.uid;

    const editedDisplayIndex = event.target.dataset.recordId;

    const $editedDisplay = $(`#${cmtTargetElementId} #${parentId} .${parentId}-row_${editedDisplayIndex}`);

    $editedDisplay.addClass('cmt--hidden');
    const formWrapper = cmt.createEditFormWrapper();
    const $formWrapper = $(formWrapper);
    $formWrapper.insertAfter($editedDisplay);
    cmt.settings.data[editedDisplayIndex].dataViewRecordIndex = editedDisplayIndex;
    cmt.settings.data[editedDisplayIndex].answersId = event.target.dataset.answersId;

    cmt.currentForm = new FormBuilder(formWrapper, cmt.settings.contentClass.options, cmt.settings.data[editedDisplayIndex], true);
  };

  cmt.createEditFormWrapper = function () {
    const wrapper = document.createElement('li');

    cmt.editFormWrapper = wrapper;

    wrapper.classList.add('cmt-inline__content_edited');

    return wrapper;
  };

  cmt.addNewRecord = function (values) {
    if(!cmt.saveHookCallBack) {
      window.displayLoadPopup();
    }
    cmt.submitRecord(values)
      .then(callback => {
        cmt.displayCreatedRecord(values);
        cmt.closeNewForm();
        cmt.settings.data.push(values);
        cmt.createNewRecordButtonAtBottom();
        if (callback) {
          callback();
        }
        if(!cmt.saveHookCallBack) {
          cmt.createNewForm();
        }
      })
      .catch(e => {
        console.error('Error saving record', e);
      })
      .finally(() => {
        runSaveHookCallBack();
      });
  };

  cmt.editRecord = function (values) {
    if(!cmt.saveHookCallBack) {
      window.displayLoadPopup();
    }
    cmt.submitRecord(values, true)
      .then(callback => {
        cmt.closeEditForm();
        const displayIndex    = values.dataViewRecordIndex;
        const editedDisplay   = cmt.displayRows[displayIndex];
        if (editedDisplay) {
          editedDisplay.populateInputs(values);
        }
        cmt.settings.data[displayIndex] = values;
        if (callback) {
          callback();
        }
      })
      .catch(e => {
        console.error('Error editing record', e);
      })
      .finally(() => {
        runSaveHookCallBack();
      });
  };

  cmt.deleteRecord = function (recordId) {
    const deleteRecordId       = cmt.settings.uid + '-row_' + recordId;
    const deletedRecordElement = document.getElementById(deleteRecordId);
    cmt.displayRows[recordId].form.remove();
    cmt.displayRows[recordId].destroy();
    cmt.dataContainer.removeChild(deletedRecordElement);

    // If no records exist, then child count will be less than 3
    if(cmt.dataContainer.childNodes.length < 3) {
      const newRecordButtonBottomId      = 'new-' + cmt.settings.formType + '-button-bottom';
      const newRecordButtonBottomElement = document.getElementById(newRecordButtonBottomId);
      if(newRecordButtonBottomElement) {
        cmt.dataContainer.removeChild(newRecordButtonBottomElement);
      }
    }
  };

  cmt.manageEventListener = function (element, event, handler, options) {
    options = options || {};

    element.addEventListener(event, handler, options);
    if (!options.once || options.once !== true) {
      cmt.eventListeners.push({
        element : element,
        event   : event,
        handler : handler
      });
    }
  };

  cmt.toggleNewFormButtons = function(isVisible) {
    const newButtonClasses = cmt.settings.newButtonClasses;
    if (newButtonClasses && newButtonClasses.buttonIds) {
      newButtonClasses.buttonIds.forEach(id => {
        const buttonElement = cmt.targetElement.querySelector(`#${id}`);
        if(buttonElement) {
          if(isVisible) {
            buttonElement.classList.remove(cmt.settings.newButtonClasses.class);
          } else {
            buttonElement.classList.add(cmt.settings.newButtonClasses.class);
          }
        }
      });
    }
  }

  cmt.closeNewForm = function () {
    cmt.toggleNewFormButtons(true);
    cmt.eventListeners.forEach(function (listener) {
      listener.element.removeEventListener(listener.event, listener.handler);
    });

    cmt.newFormWrapper.remove();
    cmt.currentForm.destroy();
    cmt.currentForm = null;
    cmt.enableEditButton(true);
  };

  cmt.closeEditForm = function () {
    cmt.toggleNewFormButtons(true);
    cmt.eventListeners.forEach(function (listener) {
      listener.element.removeEventListener(listener.event, listener.handler);
    });
    cmt.editFormWrapper.remove();
    cmt.currentForm.destroy();
    cmt.currentForm = null;

    const parentId = cmt.settings.uid;
    let $editedDisplay;
    for(let i = 0, len = cmt.settings.data.length; i < len; i++) {
      $editedDisplay = $(`#${parentId} #${parentId}-row_${i}`);
      if($editedDisplay.hasClass('cmt--hidden')) {
        $editedDisplay.removeClass('cmt--hidden');
        break;
      }
    }

    // Re-enable the edit button
    cmt.enableEditButton(true);
  };

  function getModalContentInstance() {
    return cmt.currentForm;
  }

  function saveCurrentForm(callBack) {
    if(cmt.currentForm && cmt.currentForm.form) {
      cmt.saveHookCallBack = callBack;
      cmt.currentForm.form.submit();
    } else {
      callBack();
    }
  }

  function runSaveHookCallBack() {
    if(typeof cmt.saveHookCallBack === 'function') {
      cmt.saveHookCallBack();
    } else {
      window.hideLoadPopup();
    }
    cmt.saveHookCallBack = null;
  }

  if (cmt.targetElement !== null) {
    cmt.submitRecord = cmt.settings.contentClass.options.submitRecord;
    cmt.settings.contentClass.options.addNewRecord = cmt.addNewRecord;
    cmt.settings.contentClass.options.editRecord = cmt.editRecord;
    cmt.buildDataDisplay();
  } else {
    console.log('ERROR: CMT container with id ' + cmtTargetElementId + ' not found in DOM', 'error');
  }

  cmt.createNewFormOnLoading = function (elementId, buttonId) {
    if(cmt.currentForm) {
      return;
    }

    var isEquipmentVisible = $('#'+elementId).is(':visible');

    if (cmt.currentRecordIndex === 0 && cmt.targetElement.id === elementId && isEquipmentVisible === true) {
      
        const existingData = { 'dataViewRecordIndex': cmt.currentRecordIndex };
        const formWrapper = function () {
        const wrapper = document.createElement('div');
        cmt.newFormWrapper = wrapper;
        wrapper.classList.add('cmt-inline__content');
    
        cmt.targetElement.appendChild(wrapper);
        return wrapper;
      }();
        cmt.currentForm = new FormBuilder(formWrapper, cmt.settings.contentClass.options, existingData);

        //Hide New Equipment Btn
        const newButtonClasses = cmt.settings.newButtonClasses;
        if (newButtonClasses && newButtonClasses.buttonIds) {
            newButtonClasses.buttonIds.forEach(id => {
            const buttonElement = cmt.targetElement.querySelector(`#${id}`);
            if(buttonElement && id === buttonId) {
              buttonElement.classList.add(cmt.settings.newButtonClasses.class);
            }
          });
        }
    } 
  };

  function createNewFormOnLoad(elementId, buttonId) {
    cmt.createNewFormOnLoading(elementId, buttonId);
  }

  return {
    displayRows             : cmt.displayRows,
    dataContainer           : cmt.dataContainer,
    closeForm               : isEdited => { isEdited ? cmt.closeEditForm() : cmt.closeNewForm(); },
    getModalContentInstance : getModalContentInstance,
    saveCurrentForm         : saveCurrentForm,
    createNewFormOnLoad     : createNewFormOnLoad
  };
};
